import { supabase } from '../lib/supabase';
import type { ServiceProvider, ServiceProviderInsert, ServiceProviderUpdate } from '../types/serviceProvider';
import { createCrudService } from '../lib/createCrudService';

const crud = createCrudService<ServiceProvider, ServiceProviderInsert, ServiceProviderUpdate>(
  'service_providers',
  { orderBy: 'name', ascending: true, stampUpdatedAt: false }
);

export const serviceProviderService = {
  ...crud,

  async getByName(name: string): Promise<ServiceProvider | null> {
    const { data, error } = await supabase
      .from('service_providers')
      .select('*')
      .eq('name', name)
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async search(query: string): Promise<ServiceProvider[]> {
    const { data, error } = await supabase
      .from('service_providers')
      .select('*')
      .ilike('name', `%${query}%`)
      .order('name');

    if (error) throw error;
    return data || [];
  },
};
